import {DriveLayout, StationLayout} from '@domain/kiln-monitoring'
import {Stack, Typography} from '@mui/material'

import {getKilnPartDimensions, roundTo} from '../../../../helpers'

interface KilnPartDimensionsScaleProps {
  selectedKilnPart: StationLayout | DriveLayout
}

export const KilnPartDimensionsScale: React.FC<KilnPartDimensionsScaleProps> = ({
  selectedKilnPart
}) => {
  const {
    distanceFrom0: {distanceFrom0InMeters},
    width: {widthInMeters}
  } = getKilnPartDimensions(selectedKilnPart)

  if (distanceFrom0InMeters === undefined || widthInMeters === undefined) {
    return null
  }

  const kilnPartLeftBoundary = roundTo(distanceFrom0InMeters)
  const kilnPartRightBoundary = roundTo(distanceFrom0InMeters + widthInMeters)

  const kilnPartDimensionsScale = `${kilnPartLeftBoundary}m - ${kilnPartRightBoundary}m`

  return (
    <Stack alignItems="center" data-test-id="kiln-part-dimensions-scale">
      <Typography>{kilnPartDimensionsScale}</Typography>
      <svg width="100%" height={15}>
        <defs>
          <marker
            id="arrow-start"
            viewBox="0 0 10 10"
            refX="0"
            refY="5"
            markerWidth="4"
            markerHeight="4"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="rgba(209, 217, 224, 1)" />
          </marker>
          <marker
            id="arrow-end"
            viewBox="0 0 10 10"
            refX="10"
            refY="5"
            markerWidth="4"
            markerHeight="4"
          >
            <path d="M 10 0 L 0 5 L 10 10 z" fill="rgba(209, 217, 224, 1)" />
          </marker>
        </defs>

        <line
          stroke="rgba(209, 217, 224, 1)"
          x1={0}
          y1={5}
          x2="100%"
          y2={5}
          strokeWidth={2}
          markerStart="url(#arrow-start)"
          markerEnd="url(#arrow-end)"
        />
      </svg>
    </Stack>
  )
}
